import Event from "../components/events/SummerFundraiser";

export default function EventPage2 () {

    return (
        <>
        <Event/>
        </>
    )
}